module.exports = __webpack_public_path__ + "static/media/ste_2016_rimini_3.b9d7dcaf.jpg";